import { Assets } from "@/utils/assets";
import { Global } from "@/utils/global";
import Phaser from "phaser";

export default class ControllerView{

    constructor(){
        //@typescript-eslint/no-empty-function
    }

    public shoot(scene: Phaser.Scene): Phaser.GameObjects.Image{
            const basei = scene.add.image(0, 0, Assets.GAME.ID, 'shoot1.png').setOrigin(1,1)
            basei.setPosition( Global.SCREEN_W * 0.97, Global.SCREEN_H * 0.96 );
        return basei;
    }

    public move(scene: Phaser.Scene): Phaser.GameObjects.Image{
            const basei = scene.add.image(0, 0, Assets.GAME.ID, 'direction.png').setOrigin(0,1)
            basei.setPosition( Global.SCREEN_W * 0.03, Global.SCREEN_H * 0.96 );
        return basei;
    }

}